import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navigation from "@/components/site/Navigation";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Services from "@/components/site/Services";
import Methods from "@/components/site/Methods";
import Pricing from "@/components/site/Pricing";
import Trust from "@/components/site/Trust";
import Faq from "@/components/site/Faq";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import Marquee from "@/components/site/Marquee";

export default function Home() {
  const location = useLocation();

  // Scroll to hash target after mount (used when navigating from other routes with /#id)
  useEffect(() => {
    if (!location.hash) return;
    const id = location.hash.slice(1);
    const scroll = () => {
      if (id === "start") {
        window.__lenis
          ? window.__lenis.scrollTo(0, { duration: 1.2 })
          : window.scrollTo({ top: 0, behavior: "smooth" });
        return;
      }
      const el = document.getElementById(id);
      if (!el) return;
      if (window.__lenis) window.__lenis.scrollTo(el, { offset: -80, duration: 1.2 });
      else el.scrollIntoView({ behavior: "smooth" });
    };
    const t = setTimeout(scroll, 350);
    return () => clearTimeout(t);
  }, [location.hash]);

  return (
    <div data-testid="page-home" className="min-h-screen bg-[#F2DFC6]">
      <Navigation />
      <main>
        <Hero />
        <Marquee variant="light" />
        <About />
        <Services />
        <Methods />
        <Pricing />
        <Trust />
        <Faq />
        <Marquee variant="dark" />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
